import { render, staticRenderFns } from "./StorageClassSelector.vue?vue&type=template&id=2a1a9d6f&"
import script from "./StorageClassSelector.vue?vue&type=script&lang=js&"
export * from "./StorageClassSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports